import { Link } from "@tanstack/react-router";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import { useRecentlyViewed } from "@/shared/hooks/useRecentlyViewed";
import type { ReportDescriptorView } from "../../types";
import { reportTitle } from "../../utils/reportI18n";

const HISOBOT_YOLI = /^\/reports\/([a-z_]+)$/;

export interface FrequentReportsProps {
	descriptors: ReportDescriptorView[];
	/** Markaz davri — havola kartalar bilan bir xil oraliqda ochiladi. */
	range: { dateFrom: string; dateTo: string };
}

/**
 * «Tez-tez ochilgan» — umumiy «Yaqinda ko'rilgan» do'konidan faqat
 * hisobot sahifalari (`/reports/<kind>`).
 *
 * ⚠️ Nom SAQLANGAN yorliqdan emas, descriptor'dan qayta tarjima
 * qilinadi — til almashtirilganda ro'yxat eski tilda qolmasin.
 * Descriptor ro'yxatida yo'q kind (o'chirilgan hisobot) ko'rsatilmaydi.
 *
 * ⚠️ `RecentItem` da vaqt yo'q, shuning uchun canvasdagi «bugun/kecha»
 * ustuni chizilmaydi. Ro'yxat bo'sh bo'lsa karta umuman chizilmaydi.
 */
export function FrequentReports({ descriptors, range }: FrequentReportsProps) {
	const { t } = useTranslation("reports");
	const { items } = useRecentlyViewed();

	const hisobotlar = items.flatMap((item) => {
		const kind = HISOBOT_YOLI.exec(item.path)?.[1];
		const descriptor = kind ? descriptors.find((d) => d.kind === kind) : undefined;

		return descriptor ? [descriptor] : [];
	});

	if (hisobotlar.length === 0) {
		return null;
	}

	return (
		<Card size="small" data-frequent-reports>
			<div className="flex flex-col gap-2">
				<span className="font-semibold text-sm">{t("hub.frequent.title")}</span>
				{hisobotlar.map((descriptor) => (
					<Link
						key={descriptor.kind}
						to="/reports/$kind"
						params={{ kind: descriptor.kind }}
						search={{ dateFrom: range.dateFrom, dateTo: range.dateTo }}
						className="text-[13px]"
					>
						{reportTitle(t, descriptor)}
					</Link>
				))}
			</div>
		</Card>
	);
}
